module.exports = __webpack_public_path__ + "static/img/yewufanwei.99c23bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainpage/yewufanwei.png
// module id = DABR
// module chunks = 18